import accessibility from './module/accessibility';
import theme from './module/theme';
import platform from './module/platform';
import webview from './module/webview';
import language from './module/language';
import common from './module/common';
import auth from './module/auth';
import filesystem from './module/filesystem';
import network from './module/network';
import download from './module/download';
import clipboard from './module/clipboard';
import appBridge, { ZoomAppBridgeError } from './module/app-bridge';
import history from './module/history';
import http from './module/http';
import apps from './module/apps';
import serviceHub from './module/service-hub';
import webServiceHub from './module/web-service-hub';
import permissions from './module/permissions';
import mobile from './module/mobile';
import { isAvailable } from './module/utils';
import type { HybridError } from './error/hybrid-error';
import type {
  Response,
  NativeAPIResponseMessage,
  JSBridge,
} from './utils/type';
import { JSServiceID } from './module/service-hub/core/js-service-types';
import {
  Bridge as bridge,
  config,
  compareVersions,
  platformBridgeChecker,
} from '@zoom/hybrid-jsbridge';
import { buildTime, version } from './version';
import { EmojiReactionSkinTone } from './module/theme/types';
export { ShortcutKeyName } from './module/webview';
export {
  UnifyWebviewPathIntention,
  UnifyWebViewFileType,
} from './module/filesystem/types';

export type * from './types';

export type {
  Response,
  NativeAPIResponseMessage,
  JSBridge,
  ZoomAppBridgeError,
  JSServiceID,
  HybridError,
  EmojiReactionSkinTone,
};

// Export web-service-hub types
export type * from './module/web-service-hub';

const buildInfo = {
  buildTime,
  version,
};

export default {
  config,
  accessibility,
  theme,
  auth,
  language,
  platform,
  webview,
  bridge,
  common,
  filesystem,
  network,
  download,
  clipboard,
  appBridge,
  history,
  http,
  apps,
  serviceHub,
  webServiceHub,
  permissions,
  mobile,
  isAvailable,
  compareVersions,
  platformBridgeChecker,
  buildInfo,
};

export {
  config,
  accessibility,
  theme,
  auth,
  language,
  platform,
  webview,
  bridge,
  common,
  filesystem,
  network,
  download,
  clipboard,
  appBridge,
  history,
  http,
  apps,
  serviceHub,
  webServiceHub,
  permissions,
  mobile,
  isAvailable,
  compareVersions,
  platformBridgeChecker,
  buildInfo,
};
